import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "formContainer" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { colspan: "7" }
const _hoisted_5 = { class: "py-3" }
const _hoisted_6 = { class: "py-3" }
const _hoisted_7 = { class: "py-3" }
const _hoisted_8 = { class: "py-3" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "py-3" }
const _hoisted_11 = { class: "py-3" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "My imports",
        text: "My imports",
        class: "mb-0"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_op_table, {
        class: "table table-striped",
        items: _ctx.importList
      }, {
        default: _withCtx((opData) => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Started on",
                  text: "Started on"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "File",
                  text: "File"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Garment",
                  text: "Garment"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Rows",
                  text: "Rows"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Inserted",
                  text: "Inserted"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Status",
                  text: "Status"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Errors",
                  text: "Errors"
                })
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (opData.data.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                  _createElementVNode("td", _hoisted_4, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.MyImportsVM[]), (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$filters.date(item.startedOn, "DD.MM.YYYY HH:mm")), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.fileName), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.garment || '-'), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(item.processedRows), 1),
                    (item.totalRows)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " / " + _toDisplayString(item.totalRows), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(item.insertedRows), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_localized_text, {
                      localizedKey: _ctx.calcStatusLabel(item.status),
                      text: _ctx.calcStatusLabel(item.status)
                    }, null, 8, ["localizedKey", "text"])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["py-3", { pointer: item.errorCount > 0 }]),
                    onClick: ($event: any) => (item.errorCount > 0 ? _ctx.showErrors(item) : null)
                  }, [
                    (item.errorCount > 0)
                      ? (_openBlock(), _createElementBlock("u", _hoisted_13, _toDisplayString(item.errorCount), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.errorCount), 1))
                  ], 10, _hoisted_12)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["items"])
    ])
  ], 64))
}